import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt, faTruck, faMapMarkerAlt, faSave, faCheck } from '@fortawesome/free-solid-svg-icons';
import { Row, Col, Button } from 'reactstrap';
import moment from 'moment';

//Components
import MainCard from '../../../components/MainCard/MainCard';
import ModalCustomized from '../../../components/Modal/Modal';
import TextField from '../../../components/TextField/TextField';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import Loading from '../../../components/Loading/Loading';

//Api
import coletasRecusadas_api from '../../../api/coletasRecusadas_api';
import destino_api from '../../../api/destino_api';
import rotaColeta_api from '../../../api/rotaColeta_api';

//Helpers
import { getSessionCookie } from '../../../helpers/cookies';
import { showMessage } from '../../../helpers/message';
import { validarCampos, objCampo } from '../../../helpers/ValidadorDeCampos';
import uuid from '../../../helpers/guid';

//Estado inicial da comprovação de destinação
function initialStateComprovacao() {
    return {
        localDestinacao: "",
        textoJustificado: "",
        anexo: {
            nome: "",
            base64: ""
        },
        OrdemColetaBaixado_Id: 0
    }
}
export default function DetalhesColetasRecusadas({ btnVoltar, id, transportadorId = 0 }) {
    //Estado de controle dos erros nos campos da comprovação de destinação
    const [errors, setErrors] = useState({});

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Dados do usuario logado no sistema
    const logado = getSessionCookie();

    //Estado de controle da apresentação do modal na tela
    const [openModal1, setOpenModal1] = useState(false);

    //Estado que guarda a opção ativa para carregar o conteudo certo no modal
    const [activeOption, setActiveOption] = useState("alterarDestino");

    //Estado que controla o titulo do modal
    const [titleModal, setTitleModal] = useState("");

    //Cabeçalhos da tabela de geradores
    const headersGeradores = [
        { value: "Nome", objectValue: "nome" },
        { value: "Endereço", objectValue: "endereco" },
        { value: "Fone", objectValue: "fone" }
    ]

    //Estado que guarda os dados da coleta recusada
    const [coletaRecusada, setColetaRecusada] = useState({});

    //Estado que guarda a lista de destinos para alterar o destino
    const [destinos, setDestinos] = useState([]);

    //Estado que guarda o destino que foi selecionado no select
    const [destino, setDestino] = useState(null);

    //Estado que guarda a lista de veiculos para alterar o veiculo
    const [veiculos, setVeiculos] = useState([]);

    //Estado que guarda o veiculo que foi selecionado no select
    const [veiculo, setVeiculo] = useState(null);

    //Justificativa para a baixa da ordem com pendencia
    const [justificativa, setJustificativa] = useState("");

    //Estado da comprovacao de destinacao
    const [comprovacaoDestinacao, setComprovacaoDestinacao] = useState(initialStateComprovacao)

    //Campos obrigatorios da comprovacao destinacao
    const camposComprovacao = [
        objCampo({ name: "localDestinacao", required: true }),
        objCampo({ name: "textoJustificado", required: true }),
    ]

    //Carrega os dados da coleta recusada
    const loadColetaRecusadas = () => {
        setLoading(true);
        coletasRecusadas_api.GetItem(id).then(response => {
            setComprovacaoDestinacao({
                ...comprovacaoDestinacao,
                ordemColetaBaixado_Id: response.data.ordemColetaBaixado_Id
            });
            setColetaRecusada(response.data);
            if (logado.acesso.sigla === "GS") {
                loadVeiculos(response.data.placaVeiculo);
            }
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }

    //Carrega os destinos ativos
    const loadDestinos = () => {
        setLoading(true);
        destino_api.GetList().then(response => {
            response.data = response.data.map(value => {
                return { value: value.id, label: value.fantasia };
            })
            setDestinos(response.data);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => {
            setLoading(false);
        })
    }

    //Carrega os veiculos disponiveis
    const loadVeiculos = (placa) => {
        setLoading(true);
        rotaColeta_api.GetVeiculosDisponiveis(transportadorId).then(response => {
            response.data = response.data.map(value => {
                return { value: value.id, label: value.placa }
            })
            const _veiculos = response.data.filter(value => value.label != placa);
            setVeiculos(_veiculos);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }

    //OnChange para os campos da comprovação destinacao
    const onChangeComprovacao = (e) => {
        const { name, value } = e.target;
        setComprovacaoDestinacao({
            ...comprovacaoDestinacao,
            [name]: value
        })
    }

    //OnChange para o anexo da comprovação da destinacao
    const onChangeAnexo = (e) => {
        const anexo = { nome: "", base64: "" };
        anexo.nomeArquivo = e.target.files[0].name;
        anexo.nome = e.target.files[0].name;
        const FR = new FileReader();

        FR.addEventListener("load", function (evt) {
            anexo.base64 = evt.target.result.split("base64,")[1];
            anexo.nome = anexo.nome.split(".");

            const extensao = anexo.nome[1];
            if (extensao != "png" && extensao != "jpg" && extensao != "jpeg") {
                showMessage("Aviso", "Apenas arquivos com extensão de imagem são aceitos", "error", null);
                return;
            }

            anexo.nome = uuid() + "." + anexo.nome[anexo.nome.length - 1];


            setComprovacaoDestinacao({
                ...comprovacaoDestinacao,
                anexo
            });

        });

        FR.readAsDataURL(e.target.files[0]);
    }

    //Carrega os dados da coleta e dos selects
    useEffect(() => {
        loadColetaRecusadas();

        if (logado.acesso.sigla === "GS" || logado.acesso.sigla === "TR") {
            loadDestinos();
        }
    }, []);

    const toggleModal1 = (e) => {
        if (!openModal1) {
            const { name } = e.target;
            switch (name) {
                case "alterarDestino": {
                    setTitleModal("Alterar Destino");
                    break;
                }
                case "alterarVeiculo": {
                    setTitleModal("Alterar Veículo");
                    break;
                }
                case "baixaPendencia": {
                    setTitleModal("Baixa ordem recusada com pendência");
                    break;
                }
                case "comprovarDestinacao": {
                    setTitleModal("Comprovar destinação");
                    break;
                }
            }
            setErrors({});
            setComprovacaoDestinacao(initialStateComprovacao);
            setActiveOption(name);
        }
        setOpenModal1(!openModal1);
    };
    //Botão de alteração de destino
    const BtnAlterarDestino = () => {
        return (
            <Button className='me-3' name='alterarDestino' color="warning text-light" onClick={toggleModal1}><FontAwesomeIcon icon={faMapMarkerAlt} /> Alterar Destino</Button>
        )

    }
    //Botão para alterar veiculo da ordem recusada
    const BtnAlterarVeiculo = () => {
        return (<Button name='alterarVeiculo' color={"primary text-light"} onClick={toggleModal1}><FontAwesomeIcon icon={faTruck} /> Alterar veiculo</Button>);

    }
    //Botão para baixar a ordem recusada com pendencia
    const BtnBaixaPendencia = () => {
        return (<Button name='baixaPendencia' color={"success text-light"} onClick={toggleModal1}><FontAwesomeIcon icon={faCheck} /> Baixar Pendência</Button>);

    }
    //Botão para comprovar a destinação da coleta recusada
    const BtnComprovarDestinacao = () => {
        return (<Button name='comprovarDestinacao' color={"success text-light"} onClick={toggleModal1}><FontAwesomeIcon icon={faCheck} /> Comprovar Destinação</Button>);

    }
    //Função que controla os dados que serão exibidos de acordo com o modulo acessado
    const MainContent = () => {
        switch (logado.acesso.sigla) {
            case "GS": {
                return (
                    <div style={{ color: "#666" }}>
                        <h5 className="bg-gradient bg-primary p-2 rounded-3 text-light"><FontAwesomeIcon icon={faPencilAlt} /> Detalhes da coleta</h5>
                        <Row>
                            <Col md="12" lg="4">
                                <p><span className="fw-bold">Transportador:</span> {coletaRecusada.transportador}</p>
                            </Col>
                            <Col md="12" lg="4">
                                <p><span className="fw-bold">Motorista:</span> {coletaRecusada.motorista}</p>
                            </Col>
                            <Col md="12" lg="4">
                                <p><span className="fw-bold">Veículo:</span> {coletaRecusada.placaVeiculo}</p>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12" lg="4">
                                <p><span className="fw-bold">Destino:</span> {coletaRecusada.destino}</p>
                            </Col>
                            <Col md="12" lg="8">
                                <p><span className="fw-bold">Modalidade:</span> {coletaRecusada.modalidade}</p>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12" lg="4">
                                <p><span className="fw-bold">Data da Recusa:</span> {moment(coletaRecusada.dataHora).format("DD/MM/YYYY HH:mm:ss")}</p>
                            </Col>
                            <Col md="12" lg="8">
                                <p><span className="fw-bold">Justificativa:</span> {coletaRecusada.justificativa}</p>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={"12"} lg={"12"}>
                                <p><span className="fw-bold">Anexo:</span></p>
                                <img width="200px" id="img_anexo" src={coletaRecusada.anexo}></img>
                            </Col>
                        </Row>
                        {
                            coletaRecusada.comprovacaoDestinacao &&
                            <>
                                <h5 className="bg-gradient bg-primary p-2 rounded-3 text-light"><FontAwesomeIcon icon={faPencilAlt} /> Comprovação de destinação</h5>
                                <Row>
                                    <Col md="12" lg="12">
                                        <p><span className="fw-bold">Local da destinação:</span> {coletaRecusada.comprovacaoDestinacao.localDestinacao}</p>
                                    </Col>
                                    <Col md="12" lg="12">
                                        <p><span className="fw-bold">Justificativa:</span> {coletaRecusada.comprovacaoDestinacao.textoJustificado}</p>
                                    </Col>
                                    <Col md="12" lg="12">
                                        <p><span className="fw-bold">Anexo:</span></p>
                                    </Col>
                                    <Col md={"12"} lg={"12"} className="text-center">
                                        <img width="300px" id="img_anexo" src={coletaRecusada.comprovacaoDestinacao.anexo.nome}></img>
                                    </Col>
                                </Row>
                            </>
                        }
                    </div>
                )
            }
            case "TR": {
                return (
                    <div style={{ color: "#666" }}>
                        <h5 className="bg-gradient bg-primary p-2 rounded-3 text-light"><FontAwesomeIcon icon={faPencilAlt} /> Detalhes da coleta</h5>
                        <Row>
                            <Col md="12" lg="4">
                                <p><span className="fw-bold">Motorista:</span> {coletaRecusada.motorista}</p>
                            </Col>
                            <Col md="12" lg="4">
                                <p><span className="fw-bold">Veículo:</span> {coletaRecusada.placaVeiculo}</p>
                            </Col>
                            <Col md="12" lg="4">
                                <p><span className="fw-bold">Destino:</span> {coletaRecusada.destino}</p>
                            </Col>
                        </Row>
                        <Row>

                            <Col md="12" lg="6">
                                <p><span className="fw-bold">Justificativa:</span> {coletaRecusada.justificativa}</p>
                            </Col>
                            <Col md="12" lg="6">
                                <p><span className="fw-bold">Data/Hora da Recusa:</span> {moment(coletaRecusada.dataHora).format("DD/MM/YYYY HH:mm:ss")}</p>
                            </Col>
                        </Row>
                        {coletaRecusada.anexo &&
                            <Row>
                                <Col md="12" lg="6">
                                    <span className="fw-bold ">Anexo:</span>
                                    <p><img width="200px" id="img_logotipo" src={coletaRecusada.anexo}></img></p>
                                </Col>
                            </Row>
                        }
                        <h5 className="bg-gradient bg-primary p-2 rounded-3 text-light"><FontAwesomeIcon icon={faMapMarkerAlt} /> Geradores</h5>

                        <TabelaListagem headers={headersGeradores} items={coletaRecusada.geradores ? coletaRecusada.geradores : []} options={{ print: false, search: true, pagination: true }} />
                    </div>
                )
            }
        }
    }
    //Função que é executada apos clicar no botão de confirmar do modal
    const onSubmit = () => {
        setLoading(true);

        switch (activeOption) {
            case "alterarDestino": {
                if (!destino) {
                    setLoading(false);
                    return;
                }
                coletasRecusadas_api.AlterarDestinoOrdemRecusada(destino.value, id).then(response => {
                    showMessage("Sucesso", "Destino alterado com sucesso!", "success", btnVoltar);
                }).catch(e => {
                    showMessage("Aviso", e.message, "error", null);
                }).finally(f => setLoading(false));
                break;
            }
            case "alterarVeiculo": {
                if (!veiculo) {
                    setLoading(false);
                    return;
                }
                coletasRecusadas_api.AlterarVeiculoOrdemRecusada(veiculo.value, id).then(response => {
                    showMessage("Sucesso", "Veículo alterado com sucesso!", "success", btnVoltar);
                }).catch(e => {
                    showMessage("Aviso", e.message, "error", null);
                }).finally(f => setLoading(false));
                break;
            }
            case "baixaPendencia": {
                if (justificativa == "") {
                    setLoading(false);
                    return;
                }
                coletasRecusadas_api.BaixaPendenciaOrdemRecusada(id, justificativa).then(response => {
                    showMessage("Sucesso", "Pendência baixada com sucesso!", "success", btnVoltar);
                }).catch(e => {
                    showMessage("Aviso", e.message, "error", null);
                }).finally(f => setLoading(false));
                break;
            }
            case "comprovarDestinacao": {
                const _errors = validarCampos(comprovacaoDestinacao, camposComprovacao);
                if (comprovacaoDestinacao.anexo.nome === "") {
                    _errors[1].push("anexo");
                    _errors[0].anexo = { message: "" };
                }
                if (_errors[1].length > 0) {
                    setErrors(_errors[0]);
                    setLoading(false);
                    return;
                }
                const _comprovacaoDestinacao = {
                    ...comprovacaoDestinacao,
                    ordemColetaBaixado_Id: coletaRecusada.ordemColetaBaixado_Id
                }
                coletasRecusadas_api.ComprovarDestinacao(_comprovacaoDestinacao).then(response => {
                    setComprovacaoDestinacao(initialStateComprovacao);
                    showMessage("Sucesso", "Destinação comprovada com sucesso!", "success", btnVoltar);
                }).catch(e => {
                    showMessage("Aviso", e.message, "error", null);
                }).finally(f => setLoading(false));
                break;
            }

        }
    }
    
    return (
        <MainCard btnVoltar={btnVoltar} BtnAction1={
            (logado.acesso.sigla === "GS" && coletaRecusada.id && coletaRecusada.gerarPendencia !== "SIM" && !coletaRecusada.comprovacaoDestinacao) || (!coletaRecusada.comprovacaoDestinacao && logado.acesso.sigla === "TR")
                ? BtnAlterarDestino : null
        }
            BtnAction2={logado.acesso.sigla === "GS" && coletaRecusada.id
                ? coletaRecusada.gerarPendencia !== "SIM" && !coletaRecusada.comprovacaoDestinacao
                    ? BtnAlterarVeiculo : BtnBaixaPendencia
                : null}
        >
            {loading && <Loading />}
            {logado.acesso.sigla === "GS" || (!coletaRecusada.ComprovacaoDestinacao && logado.acesso.sigla === "TR") ?
                <ModalCustomized isOpen={openModal1} toggle={toggleModal1} title={titleModal} btnClose onClickBtnAction={onSubmit} btnAction={<><FontAwesomeIcon className='me-3' icon={faCheck} /> Confirmar</>} btnActionColor={"success"}>
                    {
                        activeOption == "alterarDestino" && (
                            <div>
                                <Row>
                                    <Col md="12" lg="12">
                                        <TextField label={"Escolha o destino"} type="select" searchable options={destinos} onChange={e => setDestino(e)} value={destino} invalid={destino ? false : true} />
                                    </Col>
                                </Row>
                            </div>
                        )
                    }
                    {
                        activeOption == "alterarVeiculo" && (
                            <div>
                                <Row>
                                    <Col md="12" lg="12">
                                        <TextField label={"Escolha o veículo"} type="select" searchable options={veiculos} onChange={e => setVeiculo(e)} value={veiculo} invalid={veiculo ? false : true} />
                                    </Col>
                                </Row>
                            </div>
                        )
                    }
                    {
                        activeOption == "baixaPendencia" && (
                            <div>
                                <Row>
                                    <Col md="12" lg="12">
                                        <TextField label={"Justificativa"} type={"textarea"} onChange={e => setJustificativa(e.target.value)} value={justificativa} maxLength={"200"} invalid={justificativa === "" ? true : false} />
                                    </Col>
                                </Row>
                            </div>
                        )
                    }
                    {
                        activeOption == "comprovarDestinacao" && (
                            <div>
                                <Row>
                                    <Col md="12" lg="12">
                                        <TextField label={"Local da destinação"} name={"localDestinacao"} onChange={onChangeComprovacao} value={comprovacaoDestinacao.localDestinacao} maxLength={"100"} invalid={!!errors.localDestinacao} />
                                    </Col>
                                    <Col md="12" lg="12">
                                        <TextField label={"Justificativa"} name={"textoJustificado"} type={"textarea"} onChange={onChangeComprovacao} value={comprovacaoDestinacao.textoJustificado} invalid={!!errors.textoJustificado} />
                                    </Col>
                                    <Col md="12" lg="12">
                                        <TextField label={"Anexo"} name={"anexo"} type={"file"} onChange={onChangeAnexo} invalid={!!errors.anexo} />
                                    </Col>
                                    {comprovacaoDestinacao.anexo.base64 != "" &&
                                        <Col md={"12"} lg={"12"} className="text-center">
                                            <img width="300px" id="img_logotipo" src={"data:image/png;base64," + comprovacaoDestinacao.anexo.base64}></img>
                                        </Col>
                                    }
                                </Row>
                            </div>
                        )
                    }
                </ModalCustomized>
                :
                <></>
            }
            <MainContent />
        </MainCard >
    )
}